import React from 'react';
import Footer from '../../components/Footer';
import NosValeursHeader from './NosValeursHeader';
import ValeursContainers from './ValeursContainers';
import NosValeurs from './NosValeurs';

const NosValeursPage = () => {
  const valeurs = [
    {
      title: 'Respect',
      description: 'Nous valorisons chaque individu et nous agissons avec intégrité et transparence.',
    },
    {
      title: 'Innovation',
      description: 'Nous cherchons constamment des solutions nouvelles pour améliorer nos services.',
    },
    {
      title: 'Engagement',
      description: 'Nous sommes dédiés à la satisfaction de nos usagers et à la préservation de l’environnement.',
    },
  ];

  return (
    <div>
      {/* Composant d'en-tête */}
      <NosValeursHeader />
      <ValeursContainers />
      <NosValeurs />
      <Footer />

      {/* Section des valeurs */}
    </div>
  );
};

export default NosValeursPage;
